// @flow
import * as React from 'react';
import { reduxForm, change } from 'redux-form';
import styled from "styled-components";
import { connect } from 'react-redux';
import { ButtonPrimary } from "../../../components";

const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	padding: 1em;
	button {
		flex-basis: 65%;
		text-transform: uppercase;
	}
`;

type Props = {
	field_name: string,
	handleSubmit: Function,
	disabled_submit:boolean,
	email_fields:string,
	changeFieldValue: Function,
	invites: [{
		firstname: string,
		email: string
	}]
}

class EmailInviteFormComp extends React.Component<Props> {

	componentDidUpdate(prev_props) {
		// console.log(this.props);
		if(prev_props.invites.length === 0 && this.props.invites.length > 0) {
			this.props.changeFieldValue(`invites`, this.props.invites);
		}
	}
	render() {
		const { handleSubmit, email_fields,disabled_submit } = this.props;
		return (
			<form onSubmit={handleSubmit} autoComplete="off">
				{email_fields}
				<ButtonWrapper>
					<ButtonPrimary disabled={disabled_submit?true:false}  type="submit">
						Send Invites
					</ButtonPrimary>
				</ButtonWrapper>

			</form>
		);
	}
}
export const EmailInviteForm = reduxForm({
	form: 'invite'
})(EmailInviteFormComp);


const mapDispatchToProps = dispatch => {
	return {
		changeFieldValue: function(field, value) {
			dispatch(change('invite', field, value));
		},
	};
};


export default connect(null, mapDispatchToProps)(EmailInviteForm);


// WEBPACK FOOTER //
// ./src/pages/league/invites/emailInviteForm.js